import { TAbortError } from "@data-types/http/AbortError";

export function createAbortError(error: Error): TAbortError {
	return {
		error,
		headers: null,
		statusCode: -1,
		statusText: "",
		data: null,
	};
}
